import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M1.56 5.32c-.762.763-.327 2.07.741 2.222a3.722 3.722 0 0 1 3.053 2.662l.71 2.486a1.417 1.417 0 0 0 2.364.613l2.204-2.204 3.712 3.712a.75.75 0 1 0 1.06-1.06l-3.711-3.713 2.204-2.204a1.417 1.417 0 0 0-.613-2.364l-2.486-.71a3.722 3.722 0 0 1-2.662-3.053C7.983.64 6.677.204 5.914.967L1.561 5.32Zm8.826.882a5.222 5.222 0 0 1-3.67-3.916L2.88 6.123a5.222 5.222 0 0 1 3.916 3.669l.671 2.35 5.269-5.269-2.35-.671Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n
];
function r(a, d) {
  return e(), t("svg", l, [...c]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
